<template>
  <v-container>
    <h1
      @click="refresh()"
      v-if="myself.configprops.titulo"
      class="text-xs-left"
    >
      {{ myself.lista.modulo.mod_titulo }}
    </h1>

    <v-dialog v-model="myself.errorBox.display" max-width="400">
      <v-alert
        :value="true"
        color="error"
        icon="warning"
        class="text-xs-left"
        v-html="myself.errorBox.text"
      ></v-alert>

      <v-btn @click="myself.errorBox.display = false"> Fechar </v-btn>
    </v-dialog>

    <v-dialog v-model="myself.alertBox.display" max-width="400">
      <v-alert
        :value="true"
        color="success"
        icon="check_circle"
        class="text-xs-left"
        v-html="myself.alertBox.text"
      ></v-alert>

      <v-btn @click="myself.alertBox.display = false"> Fechar </v-btn>
    </v-dialog>

    <v-progress-circular
      v-if="myself.loading == true"
      :size="70"
      :width="7"
      color="purple"
      indeterminate
    ></v-progress-circular>

    <v-card
      class="pa-2 text-xs-left right mb-1"
      style="min-width: 200px"
      v-if="myself.configprops.filtro && myself.loading == false"
    >
      <v-icon
        class="right"
        style="cursor: pointer"
        @click="filtrobox = !filtrobox"
        >{{ !filtrobox ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon
      >
      <h2 @click="filtrobox = !filtrobox">Filtros</h2>
      <v-divider></v-divider>

      <table
        v-if="filtrobox"
        class="elevation-0 tabelaFiltroMetaReport"
        border="1"
      >
        <tr v-for="(campo, index) in myself.lista.filtros" :key="index">
          <th valign="top">{{ campo.cmp_titulo }}</th>
          <td>
            <crudcampo
              modo="filtro"
              :crud="myself"
              v-model="myself.filtro[campo.cmp_coluna]"
              :campo="campo"
              :row="myself.filtro"
            ></crudcampo>
          </td>
          <td>
            <v-icon small @click="myself.clearFiltro(campo)">
              remove_circle
            </v-icon>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="text-xs-right">
            <v-btn color="success" small @click="myself.filtrar()"
              >Buscar</v-btn
            >
          </td>
        </tr>
      </table>
    </v-card>

    <div style="clear: both"></div>

    <v-btn
      v-if="myself.configprops.gc"
      class="right"
      small
      color="blue"
      dark
      @click="myself.gerenciarCampos()"
      >Gerenciar campos</v-btn
    >

    <v-dialog
      v-if="myself.configprops.gc && myself.gerenciarDialog"
      width="500"
      hide-overlay
      transition="dialog-bottom-transition"
      v-model="myself.gerenciarDialog"
    >
      <v-card>
        <v-toolbar color="blue">
          <v-toolbar-title>Colunas a serem exibidas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="myself.gerenciarCampos()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <md-subheader
            >Selecione as colunas que devem ser exibidas na
            listagem</md-subheader
          >
          <md-list>
            <div class="gercampos">
              <md-list-item
                v-for="(co, index) in myself.lista.campos"
                :trid="co.cmp_coluna"
                class="gerlinha"
                :key="index"
              >
                <md-checkbox
                  v-model="myself.hideCols[co.cmp_coluna]"
                  :value="undefined"
                  @change="myself._fillDataTable('colchanged')"
                />
                <span class="md-list-item-text">{{ co.cmp_titulo }}</span>
              </md-list-item>
            </div>
          </md-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-speed-dial
      class="right"
      v-model="myself.fab"
      :open-on-hover="true"
      direction="left"
      v-if="myself.configprops.exportscreen !== false"
    >
      <v-btn
        slot="activator"
        v-model="myself.fab"
        color="blue darken-2"
        dark
        fab
        small
        style="zoom: 75%"
      >
        <v-icon>share</v-icon>
        <v-icon>close</v-icon>
      </v-btn>

      <v-btn
        fab
        dark
        color="green"
        small
        @click="myself.gerarExcel($refs)"
        v-if="myself.configprops.exportscreen.indexOf('e') !== -1"
      >
        XLS
      </v-btn>
      <v-btn
        fab
        dark
        color="indigo"
        small
        @click="myself.gerarPDF($refs)"
        v-if="myself.configprops.exportscreen.indexOf('p') !== -1"
      >
        PDF
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="red"
        @click="myself.gerarJSON($refs)"
        v-if="myself.configprops.exportscreen.indexOf('j') !== -1"
      >
        JSON
      </v-btn>
      <v-btn
        fab
        dark
        small
        @click="myself.gerarCSV($refs)"
        color="orange"
        v-if="myself.configprops.exportscreen.indexOf('c') !== -1"
      >
        CSV
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="grey"
        @click="myself.gerarPrint()"
        v-if="myself.configprops.exportscreen.indexOf('i') !== -1"
      >
        <v-icon>print</v-icon>
      </v-btn>
    </v-speed-dial>

    <v-data-table
      ref="datatableObj"
      v-if="myself.resultset != null"
      v-show="myself.loading == false"
      v-model="myself.selected"
      :headers="myself.headers"
      :items="myself.resultset"
      :pagination.sync="myself.paginationActive"
      :total-items="myself.totalItems"
      :rows-per-page-items="[
        myself.paginationActive != null
          ? myself.paginationActive.rowsPerPage
          : null,
      ]"
      rows-per-page-text="Registros por página"
      :loading="myself.loadingIntra"
      item-key="id"
      class="mt-2 elevation-1"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template slot="headers" slot-scope="props">
        <tr>
          <th
            v-if="myself.configprops.select && myself.lista.modulo.mod_numero"
          >
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.native="myself._toggleAll"
            ></v-checkbox>
          </th>

          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column',
              header.sortable !== false ? 'sortable' : '',
              myself.paginationActive.descending ? 'desc' : 'asc',
              header.sortable ? ' boldlink' : '',
              header.value === myself.paginationActive.sortBy ? 'active' : '',
            ]"
          >
            <span @click="myself._changeSort(header)">
              <v-icon small v-if="header.sortable !== false"
                >arrow_upward</v-icon
              >
              {{ header.text }}
            </span>
          </th>
          <th></th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <tr
          :active="props.selected"
          :trid="props.item['id']"
          :class="props.item['tr_class']"
        >
          <td
            class="noexport"
            v-if="myself.configprops.select && myself.lista.modulo.mod_numero"
            @click="props.selected = !props.selected"
          >
            <v-checkbox
              :input-value="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>

          <td v-for="coluna in myself.headers" :key="coluna.text">
            <crudcampo
              :crud="myself"
              v-model="props.item[coluna.value]"
              :campo="coluna.campo"
              :row="props.item"
            ></crudcampo>
          </td>
          <td class="noexport justify-center layout px-0">
            <span
              v-for="(custom, indc) in myself.lista.custom"
              :key="'cs_' + indc"
              @click="
                myself
                  .evaluatedCustom(custom, props.item.id, props.item)
                  .action(props.item.id, props.item)
              "
            >
              <template v-if="custom.cus_massa == false">
                <span
                  v-if="
                    myself.evaluatedCustom(custom, props.item.id, props.item)
                      .html
                  "
                  v-html="
                    myself.evaluatedCustom(custom, props.item.id, props.item)
                      .html
                  "
                ></span>
                <v-btn small v-else>{{
                  myself.evaluatedCustom(custom, props.item.id, props.item).name
                }}</v-btn>
              </template>
            </span>
          </td>
        </tr>
      </template>
      <template slot="pageText" slot-scope="props">
        Exibindo {{ props.pageStart }} até {{ props.pageStop }} de
        <b>{{ props.itemsLength }}</b>
      </template>
      <template slot="footer">
        <td class="text-xs-left">Totalização:</td>

        <td v-for="coluna in myself.headers" :key="coluna.text">
          <strong v-if="coluna.campo.operacao != null">
            <crudcampo
              :crud="myself"
              v-model="myself.resultsoma[coluna.value]"
              :campo="coluna.campo"
              :row="myself.resultsoma"
            ></crudcampo>
          </strong>
        </td>
        <td></td>
      </template>
      <template slot="no-data">
        <v-alert
          :value="true"
          color="grey"
          icon="warning"
          v-if="myself.loading == false"
        >
          Nenhum registro encontrado.
        </v-alert>
        <div v-if="myself.loading == true">&nbsp;</div>
      </template>
    </v-data-table>

    <div class="text-xs-left">
      <span
        v-for="(custom, indc) in myself.lista.custom"
        :key="indc"
        @click="
          myself
            .evaluatedCustom(custom, myself.selected, null)
            .action(myself.selected, null)
        "
      >
        <template v-if="custom.cus_massa == true">
          <span
            v-if="myself.evaluatedCustom(custom, myself.selected, null).html"
            v-html="myself.evaluatedCustom(custom, myself.selected, null).html"
          ></span>
          <v-btn small v-else>{{
            myself.evaluatedCustom(custom, myself.selected, null).name
          }}</v-btn>
        </template>
      </span>
    </div>

    <v-speed-dial
      class="right"
      v-model="myself.fab2"
      :open-on-hover="true"
      direction="left"
      v-if="myself.configprops.exportserver !== false"
    >
      <v-btn
        slot="activator"
        v-model="myself.fab2"
        color="blue darken-2"
        dark
        fab
        small
        style="zoom: 75%"
      >
        <v-icon>share</v-icon>
        <v-icon>close</v-icon>
      </v-btn>

      <v-btn
        fab
        dark
        color="green"
        small
        @click="myself.gerarExcel($refs, 1)"
        v-if="myself.configprops.exportserver.indexOf('e') !== -1"
      >
        XLS
      </v-btn>
      <v-btn
        fab
        dark
        color="indigo"
        small
        @click="myself.gerarPDF($refs, 1)"
        v-if="myself.configprops.exportserver.indexOf('p') !== -1"
      >
        PDF
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="red"
        @click="myself.gerarJSON($refs, 1)"
        v-if="myself.configprops.exportserver.indexOf('j') !== -1"
      >
        JSON
      </v-btn>
      <v-btn
        fab
        dark
        small
        @click="myself.gerarCSV($refs, 1)"
        color="orange"
        v-if="myself.configprops.exportserver.indexOf('c') !== -1"
      >
        CSV
      </v-btn>
    </v-speed-dial>
  </v-container>
</template>

<script>
/* eslint-disable */
import Vue from "vue";

try {
  var _base = require("@/page/_base.vue").default;
} catch (err) {
  var _base = require("@/framework/page/_base.vue").default;
}
const crudcampo = global.reqClass.requirecmpmix("@/admin/listagem/crudcampomr");

try {
  var Export2Multi = require("@/vendor/Export2Multi");
} catch (err) {
  try {
    var Export2Multi = require("@/framework/vendor/Export2Multi");
  } catch (err) {}
}

const components = { crudcampo };

export default {
  extends: _base,
  props: {
    myself: this,
  },
  data() {
    return {
      action: "list",
      loading: true,
      loadingIntra: true,
      //myself: this,
      lista: {
        modulo: {},
        campos: [],
      },
      configprops: {
        //propriedade default do modulo (o que mostra ou nao)
        filtro: true,
        gc: true,
        titulo: true,
        rodape: true,
        paginacao: true,
        select: true,
        exportscreen: "pecji",
        exportserver: "pecj",
      },
      paginationActive: null,
      resultset: [], //dados do data-tables
      resultsoma: {}, //dados do data-tables
      headers: [], //colunas do data-tables
      totalItems: 0, //total de registros no banco de dados
      selected: [], //itens selecionados na listagem checkboxes
      metadata: {},
      metadataextra: {},

      hideCols: {},

      filtro: {},
      filtrobox: true,
      gerenciarDialog: false,
      fab: false,
      fab2: false,

      errorMsg: null, //mensagem de erro bloquente (erro de operações crud - Exemplo. Erro ao salvar)
      errorBox: {
        //Janela alert de erro
        display: false,
        text: "",
      },
      alertBox: {
        //Janela alert de mensagem normal(verde)
        display: false,
        text: "",
      },
    };
  },
  created() {
    this.myself = this;
  },

  methods: {
    onInitReport() {},
    onInit() {
      this.params = {
        filtro: this.filtro,
        pagination: this.paginationActive,
      };
      this.onInitReport();
      this.loadingIntra = true;
    },
    onLoad() {
      this.lista = this.res.definition;
      this.metadata = this.res.metadata;
      if (this.res.metadata && this.res.metadata._extra)
        this.metadataextra = this.res.metadata._extra;
      else this.metadataextra = {};

      if (this.paginationActive == null)
        this.paginationActive = {
          descending: false,
          page: 1,
          rowsPerPage: this.lista.modulo.mod_paginacao
            ? this.lista.modulo.mod_paginacao * 1
            : 20,
          sortBy: null,
          totalItems: 0,
        };

      this.paginationActive.rowsPerPage = this.lista.modulo.mod_paginacao;

      this.loadAll();
    },

    filtrar() {
      this.refresh();
    },
    clearFiltro(campo) {
      this.filtro[campo.cmp_coluna] = null;
    },

    _toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.resultset.slice();
    },
    _changeSort(header) {
      const column = header.value;

      if (header.sortable === false) return;

      if (this.paginationActive.sortBy === column) {
        this.paginationActive.descending = !this.paginationActive.descending;
      } else {
        this.paginationActive.sortBy = column;
        this.paginationActive.descending = false;
      }
    },

    displayErrorBox(msg) {
      this.errorBox = {
        display: true,
        text: msg,
      };
    },
    displayAlertBox(msg) {
      this.alertBox = {
        display: true,
        text: msg,
      };
    },

    loadAll() {
      this._fillDataTable();

      this.resultset = this.res.resultset;
      this.resultsoma = this.res.resultsoma;

      this.totalItems = this.res.total;
      this.loading = false;
      this.loadingIntra = false;
    },

    _fillDataTable() {
      this.headers = [];
      for (let campo of this.lista.campos) {
        if (this.hideCols[campo.cmp_coluna] === undefined) {
          this.headers.push({
            text: campo.cmp_titulo,
            align: "left",
            value: campo.cmp_coluna,
            campo: campo,
            sortable: campo.cmp_ordem,
          });
        }
      }
      Vue.set(this, "headers", _.clone(this.headers));
      this.$forceUpdate();
    },

    canExecuteFunction(functionName, args) {
      if (
        functionName != null &&
        functionName.trim().substr(0, 3) == "fn." &&
        global.fn[functionName.trim().substr(3)] != null
      ) {
        return true;
      } else if (
        functionName != null &&
        functionName.trim().substr(0, 5) == "this." &&
        this[functionName.trim().substr(5)] != null
      ) {
        return true;
      } else if (
        functionName != null &&
        ((functionName.trim().substr(0, 1) == "(" &&
          functionName.indexOf("=>") != -1) ||
          (functionName.trim().substr(0, 7) == "async (" &&
            functionName.indexOf("=>") != -1) ||
          functionName.trim().substr(0, 9) == "function(" ||
          functionName.trim().substr(0, 15) == "async function(")
      ) {
        return true;
      }
      return false;
    },

    executeFunctionSync(functionName, args) {
      if (functionName != null && functionName.trim().substr(0, 3) == "fn.") {
        let fnname = functionName.trim().substr(3).trim();
        let fninstance = global.fn[fnname];
        if (fninstance != null) {
          return fninstance.apply(this, args);
        }
      }

      if (functionName != null && functionName.trim().substr(0, 5) == "this.") {
        let fnname = functionName.trim().substr(5).trim();
        let fninstance = this.classCrud[fnname];

        if (fninstance != null) {
          return fninstance.apply(this.classCrud, args);
        }
      }

      if (
        functionName != null &&
        ((functionName.trim().substr(0, 1) == "(" &&
          functionName.indexOf("=>") != -1) ||
          (functionName.trim().substr(0, 7) == "async (" &&
            functionName.indexOf("=>") != -1) ||
          functionName.trim().substr(0, 9) == "function(" ||
          functionName.trim().substr(0, 15) == "async function(")
      ) {
        let fninstance = eval(functionName.trim());
        if (fninstance != null) {
          return fninstance.apply(this, args);
        }
      }

      return null;
    },
    alterouPaginacao(old, newv) {
      if (_.isEqual(newv, {})) return;
      if (newv == null) return;

      if (this.action == "list") {
        console.log("CHANGED RELOAD", old, newv, this.paginationActive);
        this.refresh();
      }
    },
    gerenciarCampos() {
      this.gerenciarDialog = !this.gerenciarDialog;
    },

    evaluatedCustom(custom, id, row) {
      let ret = {
        name: null,
        action: null,
        html: null,
      };
      let arrow = null;

      let functionName = custom.cus_exibe;
      if (functionName != null && functionName.trim().substr(0, 3) == "fn.") {
        arrow = global.fn[functionName.trim().substr(3)];
      } else if (
        functionName != null &&
        functionName.trim().substr(0, 5) == "this."
      ) {
        arrow = this[functionName.trim().substr(5)];
      }
      let arrowed = null;
      if (arrow) arrowed = arrow.bind(this)(id, row);
      if (arrowed) {
        ret.name = arrowed.name(id, row);
        ret.action = arrowed.action;
        ret.html = arrowed.html(id, row);
      }
      return ret;
    },

    callAction(actionName, id, extra = {}, callback = null, callbacke = null) {
      let pact = _.clone(this.paginationActive);

      let path = this.getMyPath();
      global.express
        .meta(path, {
          actionName: actionName,
          extra: extra,
          id: id,
          paginacao: pact,
          filtro: this.filtro,
        })
        .then(callback)
        .catch(callbacke)
        .finally(() => {
          this.loading = false;
          this.loadingIntra = false;
        });
    },

    async carregaTudoJson() {
      //busca json all

      this.loadingIntra = true;

      let pact = _.clone(this.paginationActive);
      pact.porPagina = -1;

      let path = this.getMyPath();
      let apos = await global.express.meta(path, {
        filtro: this.filtro,
        paginacao: pact,
      });

      this.loadingIntra = false;
      let map = apos.resultset;

      let all = [];

      for (let mapi of map) {
        let allo = [];
        for (let no of this.headers) {
          allo.push(mapi[no.campo.cmp_coluna]);
        }
        all.push(allo);
      }

      return all;

      //return false;
    },

    async gerarExcel($refs, all = null) {
      if (all != null) {
        //busca json all
        all = await this.carregaTudoJson();
        console.log(all);
        //return false;
      }

      let tabela = $refs.datatableObj.$el.children[0].children[0];
      let headersOfTable = this.headers.map((v) => v.text);
      Export2Multi.export_table_to_excel(
        null,
        tabela,
        headersOfTable,
        this.lista.modulo.mod_titulo,
        all
      );
    },

    async gerarCSV($refs, all = null) {
      if (all != null) {
        //busca json all
        all = await this.carregaTudoJson();
        console.log(all);
        //return false;
      }

      let tabela = $refs.datatableObj.$el.children[0].children[0];
      let headersOfTable = this.headers.map((v) => v.text);
      Export2Multi.export_table_to_csv(
        null,
        tabela,
        headersOfTable,
        this.lista.modulo.mod_titulo,
        all
      );
    },

    async gerarJSON($refs, all = null) {
      if (all != null) {
        //busca json all
        all = await this.carregaTudoJson();
        console.log(all);
        //return false;
      }

      let tabela = $refs.datatableObj.$el.children[0].children[0];
      let headersOfTable = this.headers.map((v) => v.text);
      Export2Multi.export_table_to_json(
        null,
        tabela,
        headersOfTable,
        this.lista.modulo.mod_titulo,
        all
      );
    },
    async gerarPDF($refs, all = null) {
      if (all != null) {
        //busca json all
        all = await this.carregaTudoJson();
        console.log(all);
        //return false;
      }

      let tabela = $refs.datatableObj.$el.children[0].children[0];
      let headersOfTable = this.headers.map((v) => v.text);
      Export2Multi.export_table_to_pdf(
        null,
        tabela,
        headersOfTable,
        this.lista.modulo.mod_titulo,
        all
      );
    },
    gerarPrint() {
      window.print();
    },
  },
  watch: {
    paginationActive: {
      handler(old, newv) {
        this.alterouPaginacao(old, newv);
      },
      deep: true,
    },
  },
  components,
};
</script>

<style>
.tabelaFiltroMetaReport {
  border-collapse: collapse;
}
.tabelaFiltroMetaReport tr td,
.tabelaFiltroMetaReport tr th {
  border: solid #eee 1px;
  padding: 2px;
}
</style>
